// extracted by mini-css-extract-plugin
module.exports = {"intake-form":"IntakeForm_intake-form__F4b_f"};